"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bentenmaru = void 0;
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Card_1 = require("../../Card");
const Tags_1 = require("../../Tags");
const Resources_1 = require("../../../Resources");
const Size_1 = require("../../render/Size");
class Bentenmaru extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.BENTENMARU,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 25,
            metadata: {
                cardNumber: 'R58',
                description: 'You start with 25 M€ and 10 M€ production.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(25).production((pb) => pb.megacredits(10));
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('When you take an action that would decrease an OPPONENT\'s production or resources, increase YOUR production or resources by that amount instead.', (eb) => {
                            eb.minus(Size_1.Size.SMALL).wild(1).any.production((pb) => pb.wild(1).any);
                            eb.startEffect.wild(1).production((pb) => pb.wild(1));
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.text('EFFECT: Each generation, when you pass, discard all your remaining M€.', Size_1.Size.TINY, true);
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 10);
        return undefined;
    }
}
exports.Bentenmaru = Bentenmaru;
//# sourceMappingURL=Bentenmaru.js.map